// extracted by mini-css-extract-plugin
export default {"periodTimeContainer":"PeriodTimePicker_periodTimeContainer__6cOMu","arrowIcon":"PeriodTimePicker_arrowIcon__W3GYa","opened":"PeriodTimePicker_opened__SGnuJ"};